import {exists, isObject, isString, isNumber, isBoolean} from '../../../util';
const Types = {
	object:'object',
	array:'array',
	string:'string',
	number:'number',
	boolean:'boolean',
	json: 'json',
	unkown:'unknown'
};

const DefaultTypeValues = {
	[Types.object]: () => ({}),
	[Types.array]: () => ([]),
	[Types.string]: () => ' ',
	[Types.number]: () => 1,
	[Types.boolean]: () => true,
};

export function getValueType(value) {
	if(Array.isArray(value)) return Types.array;
	if(isObject(value)) return Types.object;
	if(isString(value)) return Types.string;
	if(isNumber(value)) return Types.number;
	if(isBoolean(value)) return Types.boolean;
	return Types.unkown;
}


export function defaultValueFor(type) {
	if(exists(DefaultTypeValues[type])) return DefaultTypeValues[type]();
	return null;
}

export function isCompositeType(type) {
	return type === Types.object || type === Types.array;
}


export default Types;